import * as React from 'react';

import { Box, HStack, Link, Text, VStack } from '@chakra-ui/react';

const currentYear = new Date().getFullYear();

const CambiaFooter: React.FC = () => (
  <VStack
    bgColor="#0a94cf"
    color="white"
    padding="24px 2% 16px"
    textAlign="center"
  >
    <Box>
      <HStack spacing={5}>
        <Link isExternal href="https://hr.rikeimatch.jp/recruiting">
          採用企業様はこちら
        </Link>
        <Link isExternal href="https://cambiainc.co.jp/">
          運営会社
        </Link>
        <Link href="/tos.html">利用規約</Link>
        <Link href="/privacy.html">プライバシーポリシー</Link>
      </HStack>
    </Box>
    <Box paddingLeft={10} paddingY={5}>
      <Text>©{currentYear} Cambia</Text>
    </Box>
  </VStack>
);

export default CambiaFooter;
